import { getFormattedDateTime } from './getFormattedDateTime'

export const getFormattedTime = (
  date?: Date,
  locale?: string,
  inputOptions?: Omit<Intl.DateTimeFormatOptions, 'dateStyle'>,
) => {
  const options: Intl.DateTimeFormatOptions = {
    ...(!inputOptions?.timeStyle
      ? {
          hour: '2-digit',
          minute: '2-digit',
        }
      : {}),
    ...(inputOptions || {}),
    dateStyle: undefined,
  }

  return getFormattedDateTime(date, locale, options)
}
